import { useMutation } from '@apollo/client';

import {
  AddProductToCart,
  AddProductToCartVariables,
} from '../queries/__generated__/AddProductToCart';
import {
  CartAddProductWithService,
  CartAddProductWithServiceVariables,
} from '../queries/__generated__/CartAddProductWithService';
import addtoCartMutation from '../queries/addToCart.graphql';
import addProductsToCartWithServiceMutation from '../queries/addToCartDeprecated.graphql';

export const useAddToCart = () => {
  const [cartAddToCartDeprecated] = useMutation<
    CartAddProductWithService,
    CartAddProductWithServiceVariables
  >(addProductsToCartWithServiceMutation, {
    refetchQueries: ['getServicesIncluded'],
  });

  const [addToCart] = useMutation<AddProductToCart, AddProductToCartVariables>(
    addtoCartMutation,
    {
      refetchQueries: ['getServicesIncluded'],
    }
  );

  return {
    mutations: {
      cartAddToCartDeprecated,
      addToCart,
    },
  };
};
